import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const GizlilikPage = () => (
  <div className="min-h-screen bg-slate-50">
    <Navbar />
    <div className="pt-16 md:pt-20 bg-slate-900 text-white py-12">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-4xl font-extrabold mb-3">Gizlilik Politikası</h1>
        <p className="text-slate-400 text-sm">Son güncelleme: Nisan 2026</p>
      </div>
    </div>
    <div className="max-w-4xl mx-auto px-4 md:px-6 py-14 space-y-8">
      {[
        {
          title: '1. Toplanan Bilgiler',
          content: 'Sitemizi ziyaret ettiğinizde veya iletişim formunu doldurduğunuzda ad, e-posta adresi, telefon numarası gibi kişisel bilgilerinizi toplayabiliriz. Bu bilgiler yalnızca sizinle iletişim kurmak amacıyla kullanılır.',
        },
        {
          title: '2. Bilgilerin Kullanımı',
          content: 'Topladığımız kişisel bilgiler; teknik destek taleplerinizi yanıtlamak, ürün ve hizmetlerimiz hakkında bilgi vermek, siparişlerinizi işlemek ve müşteri hizmetleri sunmak amacıyla kullanılmaktadır. Bilgileriniz üçüncü taraflarla paylaşılmaz.',
        },
        {
          title: '3. Çerezler (Cookies)',
          content: 'Sitemiz, kullanıcı deneyimini iyileştirmek amacıyla çerezler kullanabilir. Tarayıcı ayarlarınızdan çerezleri devre dışı bırakabilirsiniz; ancak bu durumda sitenin bazı özellikleri düzgün çalışmayabilir.',
        },
        {
          title: '4. Veri Güvenliği',
          content: 'Kişisel verilerinizin güvenliği bizim için önemlidir. Verilerinizi yetkisiz erişime, değiştirilmeye veya ifşa edilmeye karşı korumak için uygun teknik ve idari önlemler alınmaktadır.',
        },
        {
          title: '5. Üçüncü Taraf Bağlantılar',
          content: 'Sitemiz, üçüncü taraf web sitelerine bağlantılar içerebilir. Bu sitelerin gizlilik politikalarından sorumlu değiliz. Bağlantıları takip etmeden önce ilgili sitenin gizlilik politikasını incelemenizi öneririz.',
        },
        {
          title: '6. Haklarınız',
          content: 'KVKK kapsamında kişisel verilerinize erişme, düzeltme, silme veya işlenmesini kısıtlama hakkına sahipsiniz. Bu haklarınızı kullanmak için goldsbilisim06@gmail.com adresine e-posta gönderebilirsiniz.',
        },
        {
          title: '7. İletişim',
          content: 'Gizlilik politikamız hakkında sorularınız için: goldsbilisim06@gmail.com | 0532 541 63 44 | Çevreli Cad. Çaba Sok. No:1/D10, Aydınlıkevler / ANKARA',
        },
      ].map((section, i) => (
        <div key={i} className="bg-white rounded-xl border border-slate-100 p-6">
          <h2 className="text-lg font-bold text-slate-900 mb-3">{section.title}</h2>
          <p className="text-slate-600 text-sm leading-relaxed">{section.content}</p>
        </div>
      ))}
    </div>
    <Footer />
  </div>
);

export default GizlilikPage;
